import http from 'plugins/axios';

export default {
    getPositionList(data) {
        return http.get({
            url: '/admin/etp/holdList',
            data
        });
    },
    getPositionRadio(data) {
        return http.get({
            url: '/admin/etp/holdProportion',
            data
        });
    },
};
